<template>
    <ur-button v-bind="buttonProps"
                 v-on="$listeners"
                 :class="buttonClass"
                 @click="mToggle"><ur-icon v-bind="iconProps"><slot/></ur-icon></ur-button>
</template>
<script>
import urButton from '../urButton/urButton';
import urIcon from '../urIcon/urIcon';
// ur-icon-button 은 icon을 표시하는 버튼 컴포넌트입니다. 지정되는 icon 이름에 따른 icon을 표시합니다. 클릭과 같은 사용자의 이벤트를 처리하는 컴포넌트 입니다.
// #ur-icon is a button component that displays icons. Displays the icon according to the specified icon name. Defines a clickable button.
export default {
    name: 'ur-icon-button',
    components:{urButton, urIcon},
    props: {
        /* ICON BUTTON PROPS */

        // $ver: v0.1.0
        // Toggle 형태 버튼 여부입니다.
        // #Toggle type button.
        // $default: false
        toggle: {type:Boolean, default: false},

        // $ver: v0.1.0
        // 선택되었을 때 v-model의 값으로 설정되는 목표값입니다.
        // # If component is checked, v-model is set as this value.
        // $default: false
        value: {type:Boolean},

        /* COMMON PROPS*/
        // $ver: v0.1.0
        // 버튼의 크기가 컨테이너에 꽉 차도록 표현합니다.
        // #Makes the button fill the container.
        // $default: false
        full : {type: Boolean, default: false},
        // $ver: v0.1.0
        // 큰크기 사이즈로 표현합니다.
        // #Expressed in large size.
        // $default: false
        large : {type: Boolean, default: false},
        // $ver: v0.1.0
        // 중간크기 사이즈로 표현합니다.
        // #Expressed in medium size.
        // $default: false
        medium : {type: Boolean, default: false},
        // $ver: v0.1.0
        // 작은크기 사이즈로 표현합니다.
        // #Expressed in small size.
        // $default: false
        small: {type: Boolean, default: false},

        /* BUTTON PROPS */
        // $ver: v0.1.0
        // Solid 버튼 유형 여부입니다. true/false 값을 할당하지 않고 해당 Prop을 선언만 하면 동작합니다.
        // #Express Button as Solid. Just declare the prop without assigning it a true / false value and it will work.
        // $default: false
        solid   : {type: Boolean, default: false},
        // $ver: v0.1.0
        // Border 버튼 유형 여부입니다.
        // #Express Button as Border
        // $default: true
        border  : {type: Boolean, default: true},
        // $ver: v0.1.0
        // 버튼 비활성화 여부입니다.
        // #Whether to handle button deactivation
        // $default: false
        // $tags IDE, disabled
        disabled: {type: Boolean, default: false},
        // $ver: v0.1.0
        // #Whether to show status while button is loading
        // $default: false
        // $tags IDE, loading
        loading : {type: Boolean, default: false},
        // $ver: v0.1.0
        // Primary 색상 여부입니다.
        // #Whether to be primary color
        // $default: false
        primary: {type: Boolean, default: false},
        // $ver: v0.1.0
        // Point 색상 여부입니다.
        // #Whether the Point color
        // $default: false
        point: {type: Boolean, default: false},

        // $ver: v0.2.0
        // 아이콘의 색깔입니다.
        // # The color of the control.
        // $default: 'normal'
        // $tags: IDE
        color: {type:String, default: undefined},


        /* ICON */
        // $ver: v0.2.0
        // 아이콘의 모양입니다. 아이콘에 대한 설명은 <a href="/#/dev/comp/icon">링크</a>를 참조하십시오.
        // # Icon to display. Enter a value by referring to the OPUS Icon name
        // #See the <a href="/#/dev/comp/icon">links</a> for a description of the icons.
        // $default: 'favorite'
        // $tags: IDE
        icon: {type: String, default: undefined},

        // $ver: v0.2.0
        // 아이콘의 형태입니다. 'line', 'picto' 의 값을 입력할 수 있습니다.
        // # The type of the control.  You can enter values ​​for 'line', 'picto'.
        // $default: 'line'
        // $tags: IDE
        iconType: {
            type: String,
            default: 'line',
            validator: function(value) {
                return ['line', 'picto'].indexOf(value) !== -1;
            }
        },

        // $ver: v0.1.0
        // 아이콘 크기 입니다.
        // #This is icon size.
        // $default: inherit
        iconSize: {type: [String, Number], default:'inherit'},
        // $ver: v0.1.0
        // 여백의 여부입니다.
        // #Whether the icon spacing
        // $default: false
        spacing: {type: Boolean, default: false},

        // $ver: v0.1.0
        // $hide
        brand   : Boolean,
        // $ver: v0.1.0
        // $hide
        regular : Boolean,
        // $ver: v0.1.0
        // $hide
        light   : Boolean,
        // $ver: v0.1.0
        // $hide
        old     : Boolean,
        // $ver: v0.1.0
        // $hide:
        fab     : Boolean,
        // $ver: v0.1.0
        // $hide:
        far     : Boolean,
        // $ver: v0.1.0
        // $hide
        fal     : Boolean,
        // $ver: v0.1.0
        // $hide
        fa      : Boolean,

        // $ver: v0.1.0
        // 아이콘의 형태입니다. 'line', 'picto' 의 값을 입력할 수 있습니다.
        // # The type of the control.  You can enter values ​​for 'line', 'picto'.
        // $default: 'line'
        type: {
            type: String,
            default: 'line',
            validator: function(value) {
                return ['line', 'picto'].indexOf(value) !== -1;
            }
        },

        //$ ver:v0.2.0
        // 아이콘의 크기입니다. 'small', 'medium' 의 값을 입력할 수 있습니다.
        // # The type of the control.  You can enter values ​​for 'small', 'medium'.
        // $tags: IDE
        size: {type: [String, Number]},
        // $ver: v0.1.0
        // Borderless 버튼 유형 여부입니다.
        // #Express Button as Borderless
        // $default: false
        borderless : {type: Boolean, default: false},
        /* abbr */
        // $ver: v0.1.0
        // $abbr: border
        bor: {type: Boolean, default: false},
        // $ver: v0.1.0
        // $abbr: solid
        sol: {type: Boolean, default: false},
        // $ver: v0.1.0
        // $abbr: borderless
        bLess: {type: Boolean, default: false},
        // $ver: v0.1.0
        // $abbr: primary
        prim: {type: Boolean, default: false},
        // $ver: v0.1.0
        // $abbr: point
        pnt: {type: Boolean, default: false},
        // $ver: v0.1.0
        // $abbr: color
        col: {type: String, default: undefined},
        // $ver: v0.1.0
        // $abbr: large
        lg: {type: Boolean, default: false},
        // $ver: v0.1.0
        // $abbr: medium
        md: {type: Boolean, default: false},
        // $ver: v0.1.0
        // $abbr: small
        sm: {type: Boolean, default: false},

    },
    data(){
        return{
    }},
    computed: {
        iColor(){
            if(this.color){return this.color}
            return 'default'
        },
        buttonClass() {
            return [
            'ur-icon-button',
            this.toggle && this.value === false ? 'ur-icon-button--off': '',
            this.toggle && this.value ? 'ur-button--' + this.iColor: '',

        ]},
        buttonProps() {
            return {
                solid: this.solid,
                borderless: this.borderless,
                border: this.border,
                toggle: this.toggle,
                large: this.large,
                medium: this.medium,
                small: this.small,
                disabled: this.disabled,
                loading: this.loading,
                primary: this.primary,
                point: this.point,
                color: this.color,
                full: this.full,
                bor: this.bor,
                sol: this.sol,
                bLess: this.bLess,
                prim: this.prim,
                pnt: this.pnt,
                col: this.col,
                lg: this.lg,
                md: this.md,
                sm: this.sm,
            }
        },
        iconProps() {return {
            icon: this.icon,
            iconType: this.iconType,
            iconSize: this.iconSize,
            spacing: this.spacing,
            brand: this.brand,
            regular: this.regular,
            light: this.light,
            old: this.old,
            fab: this.fab,
            far: this.far,
            fal: this.fal,
            fa: this.fa,
            type: this.type,
            size: this.size,
        }}
    },
    methods: {
        mToggle(e) {
            if(!this.toggle) { return; }
            this.$emit('input', !this.value);
        }
    }
}
</script>
